import styled from "styled-components";
import Modal from "@material-ui/core/Modal";

export const ContainerModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default ContainerModal;
